<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-15 10:16:17
 * @LastEditTime: 2022-10-10 22:41:11
 * @LastEditors: chenguobiao
-->
<template>
  <div class="grading-index-page flex flex-col">
    <common-header selected="user" />
    <div class="grading-index-page__content flex flex-col items-center" v-if="testLogUid && question.uid">
        <div class="enter-animation" v-if="animationTimes > 0">
          <template v-if="questionType === 'ai'">
            <div class="question-type">国际象棋实战对决</div>
            <start-option-button txt='开始答题' @handleClick="handleStart"/>
          </template>
          <template v-else>
            <div class="question-type">{{questionType === 'national_iconic' ? '国际象棋战术题' : (questionType === 'ai' ? '国际象棋实战对决' : '国际象棋规则题')}}</div>
            <div class="count-down"><span>{{animationTimes}}</span>  秒后进入作答</div>
          </template>
        </div>
        <div class="question flex flex-col items-center" v-if="animationTimes === 0">
          <broadcast :question="question" ref="broadcastRef"/>
          <chess-question v-if="['national_iconic', 'ai'].includes(questionType)" ref="chessQuestionRef" :questionType="questionType" :question="question" :key="question.uid" @gameOver="handleGameOver"></chess-question>
          <choice-question v-else ref="choiceQuestionRef" :questionType="questionType" :question="question" :key="question.uid"></choice-question>
          <div class="buttons flex">
            <template v-if="['national_iconic', 'singel_selection', 'multi_selection', 'true_or_false'].includes(questionType)">
              <reset-option-button txt='复原' @handleClick="reset" v-if="questionType === 'national_iconic'"></reset-option-button>
              <next-option-button txt='下一题' @handleClick="next" v-if="!lastQuestion"></next-option-button>
              <submit-option-button txt='提交试卷' @handleClick="submit" v-else></submit-option-button>
            </template>
            <template v-else>
              <surrender-option-button txt='投降' @handleClick="surrender"></surrender-option-button>
            </template>
          </div>
        </div>
    </div>
    <chess-question-dialog class="question__dialog" :visible="questionDialogConfig.visible" :showClose="false" :noBg="true">
      <div class="question__dialog__content">
        <img v-if="answerCorrect === 0" src="@/render/assets/images/grading/grading_fail.png">
        <img v-else-if="answerCorrect === 1" src="@/render/assets/images/grading/grading_success.png">
        <img v-else src="@/render/assets/images/grading/grading_draw.png">
        <span class="next-question" @click="next" v-if="!lastQuestion">下一题  >></span>
        <span class="next-question" @click="submit" v-else>提交试卷</span>
      </div>
    </chess-question-dialog>
    <grading-result-dialog class="result__dialog" :visible="resultDialogConfig.visible" :showClose="false" :noBg="true">
      <div class="result__dialog__content">
        <div class="result__dialog__content__image" v-if="resultDialogConfig.result.pass === 0">
          <img src="@/render/assets/images/grading/pass_success.png">
        </div>
        <div class="result__dialog__content__image" v-else>
          <img src="@/render/assets/images/grading/pass_fail.png">
        </div>
        <div class="result__dialog__content__info">
          <div class="total-score" :class="{fail: resultDialogConfig.result.pass !== 0}">
            <img :src="require(`@/render/assets/images/grading/level_txt_${scoreLevel}.png`)" alt="">
          </div>
          <div class="result-info" :class="{fail: resultDialogConfig.result.pass !== 0}">
            <p>考试总用时<span>{{resultDialogConfig.result.totalTime}}</span></p>
            <template v-if="scoreLevel === 0 || scoreLevel === 1">
              <p>同级排名第<span>{{resultDialogConfig.result.rank}}</span>名</p>
              <p>超过<span :style="levelColor">{{resultDialogConfig.result.percent}}</span>同级选手。</p>
            </template>
          </div>
          <div class="level" v-if="resultDialogConfig.result.pass === 0"><span>{{resultDialogConfig.result.paperLevel}}</span></div>
          <div class="tips" :class="{fail: resultDialogConfig.result.pass !== 0}">
            <p v-if="resultDialogConfig.result.pass === 0">等级证书已下发，请前往个人中心查看</p>
            <p v-else>您可以在我的考级中申请重考，以获得考试机会。</p>
          </div>
        </div>
      </div>
      <div class="result__dialog__buttons flex justify-center">
        <div class="result__dialog__buttons__button" @click="handleReplay(resultDialogConfig.result.uid)">复盘</div>
        <div class="result__dialog__buttons__button" @click="handleMainPager">主页</div>
      </div>
    </grading-result-dialog>
  </div>
</template>

<script>
import { Timer, debounce, getScoreLevel } from '@/render/utils'
import { mapGetters } from 'vuex'
import { WS_GAME_CONFIGS, USER_INFO, Game_CountDown, GRADING_OVER, ANIMATION_COUNTDOWN, GIVE_UP } from '@/config/const'
import { ChessQuestion, ChoiceQuestion, OptionButton, Broadcast } from './components'
import { gradingAPI } from '@/apis'
import Chess from 'chess.js'
import store from 'store'
import CommonHeader from '@/render/components/common/header'
import CommonDialog from '@/render/components/common/dialog'
const newGame = new Chess()
let enterRulesFlag = false
let timer = null
export default {
  name: 'Grading',
  components: {
    CommonHeader,
    ChessQuestionDialog: CommonDialog,
    GradingResultDialog: CommonDialog,
    ChessQuestion,
    ChoiceQuestion,
    StartOptionButton: OptionButton,
    ResetOptionButton: OptionButton,
    NextOptionButton: OptionButton,
    SubmitOptionButton: OptionButton,
    SurrenderOptionButton: OptionButton,
    Broadcast
  },
  data() {
    return {
      question: {},
      lastQuestion: false,
      answerCorrect: 0,
      errorReason: '',
      questionDialogConfig: {
        visible: false
      },
      resultDialogConfig: {
        visible: false,
        result: {
        }
      },
      switchQuestionFlag: false,
      animationTimes: 0, // 动画倒计时
      orderUid: '',
      endFlag: false,
      scoreLevel: 0
    }
  },
  computed: {
    ...mapGetters('grading', ['newQuestionFlag', 'testPaper', 'currQuestionIdx', 'currQuestionTypeIdx', 'currQuestion', 'totalTime', 'eachTime', 'testLogUid', 'uids', 'moveErrorStep']),
    questionType() { // 1、国际象棋战术题 2、普通提 3、国际象棋实战对决
      return this.question.typeCode
    },
    visible() {
      return this.questionDialogConfig.visible || this.resultDialogConfig.visible
    },
    levelColor() {
      if (!this.resultDialogConfig.result.percent) return ''
      const num = Number(this.resultDialogConfig.result.percent.replace('%'))
      let color = ''
      if (!isNaN(num)) {
        color = num > 0 && num <= 20 ? '#FF4B4B' : (num > 20 && num < 80) ? '#FF9100' : '#00AEEF'
      }
      return {
        color
      }
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {
        const { orderUid } = query
        const testPaper = this.testPaper
        if (orderUid && testPaper && testPaper.detailList) {
          this.orderUid = orderUid
          testPaper.uids && this.initGrading(testPaper)
          this.startCountDown()
          this.getQuestion(testPaper)
        } else {
          this.$router.replace('/home')
        }
      }
    },
    testLogUid: {
      immediate: true,
      handler(testLogUid) {
        if (!testLogUid) this.$router.replace('/home')
      }
    },
    visible: {
      immediate: true,
      handler(visible) {
        if (visible) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.chessQuestionRef && this.$refs.chessQuestionRef.$refs.playerRef && this.$refs.chessQuestionRef.$refs.playerRef.$refs.manPlayer.stop()
            }, 20)
          })
        }
      }
    },
    questionType: {
      immediate: true,
      handler(questionType) {
        if (questionType) {
          if (['national_iconic', 'ai'].includes(questionType)) {
            this.startEnterAnimation()
            enterRulesFlag = false
          } else {
            !enterRulesFlag && this.startEnterAnimation()
            enterRulesFlag = true
          }
        }
      }
    }
  },
  provide() {
    return {
      timeOver: this.timeOver
    }
  },
  mounted() {
    this.$bus.on(GRADING_OVER, (errorReason) => {
      this.endFlag = true
      this.errorReason = errorReason || ''
      this.submit()
    })
    this.$bus.on(GIVE_UP, async () => {
      if (this.animationTimes > 0) {
        try {
          await gradingAPI.postQuitExam({
            testLogUid: this.testLogUid,
            orderUid: this.orderUid
          })
          await this.getGradingResult()
        } catch (error) {
          console.error(error)
        }
      } else {
        this.$bus.emit(GRADING_OVER, '放弃考试未完成对局')
      }
    })
    if (this.totalTime === 0) this.$bus.emit(GRADING_OVER, '未在规定时间内完成作答')
  },
  destroyed() {
    timer.stop()
    this.$bus.off(Game_CountDown)
    this.$bus.off(GRADING_OVER)
    this.$bus.off(GIVE_UP)
    this.$bus.off(ANIMATION_COUNTDOWN)
  },
  methods: {
    async initGrading(testPaper) {
      const { uids, detailList } = testPaper
      const len = uids.split(',').length
      const { currQuestionIdx, currQuestionTypeIdx } = this.getCurrQuestionIdxObject(len, detailList)
      this.$store.commit('grading/setCurrQuestionIdx', currQuestionIdx)
      this.$store.commit('grading/setCurrQuestionTypeIdx', currQuestionTypeIdx)
      this.$store.commit('grading/setUids', uids)
    },
    getCurrQuestionIdxObject(len, detailList) {
      let currQuestionIdx = len
      let currQuestionTypeIdx = 0
      let totalCount = 0
      for (let i = 0; i < detailList.length; i++) {
        totalCount += detailList[i].count
        if (len < totalCount) {
          currQuestionTypeIdx = i
          break
        } else if (len === totalCount) {
          currQuestionIdx = 0
          currQuestionTypeIdx = i + 1
          break
        } else {
          currQuestionIdx -= detailList[i].count
        }
      }
      return {
        currQuestionIdx,
        currQuestionTypeIdx
      }
    },
    handleStart() {
      this.animationTimes = 0
    },
    startCountDown() {
      timer = new Timer(this.totalTime)
      timer.start(this.$bus, Game_CountDown)
      this.$bus.on(Game_CountDown, times => {
        this.$store.commit('grading/setTotalTime', times)
        if (times === 0) {
          this.$bus.emit(GRADING_OVER, '未在规定时间内完成作答')
          timer.stop()
        }
      })
    },
    startEnterAnimation() {
      this.animationTimes = 3
      if (this.questionType === 'ai') return
      let timer = new Timer(this.animationTimes)
      timer.start(this.$bus, ANIMATION_COUNTDOWN)
      this.$bus.on(ANIMATION_COUNTDOWN, times => {
        this.animationTimes = times
      })
    },
    calculateWin () {
      newGame.reset()
      const { game } = this.$refs.chessQuestionRef.$refs.chessRef
      const { player_turn_color } = store.get(WS_GAME_CONFIGS)
      const color = game.turn() === 'w' ? 'white' : 'black'
      let is_win = 0
      if (player_turn_color !== color) {
        if (game.in_checkmate()) {
          is_win = 1
        } else if (newGame.fen() === this.question.fen && game.in_draw()) {
          is_win = 2
        }
      }
      return is_win
    },
    getErrorReason() {
      newGame.reset()
      let errorReason = this.errorReason
      if (errorReason) return errorReason
      if (this.questionType === 'ai') {
        const { game } = this.$refs.chessQuestionRef.$refs.chessRef
        const { player_turn_color } = store.get(WS_GAME_CONFIGS)
        const color = game.turn() === 'w' ? 'white' : 'black'
        const initialSituationFlag = game.fen() === this.question.fen
        if (game.in_checkmate()) {
          errorReason = player_turn_color !== color ? '将杀全分' : '被将杀'
        } else if (game.in_stalemate()) {
          errorReason = initialSituationFlag ? '和棋未能实现将杀-逼和-初始局面' : '未能实现将杀-逼和-非初始局面'
        } else if (game.in_threefold_repetition()) {
          errorReason = initialSituationFlag ? '和棋未能实现将杀-三次重复局面-初始局面' : '未能实现将杀-三次重复局面和棋-非初始局面'
        } else if (game.insufficient_material()) {
          errorReason = initialSituationFlag ? '和棋未能实现将杀-无子可剩和棋-初始局面' : '未能实现将杀-无子可剩和棋-非初始局面'
        } else if (game.in_draw()) {
          errorReason = initialSituationFlag ? '和棋未能实现将杀-50回合规则-初始局面' : '未能实现将杀-50回合规则和棋-非初始局面'
        }
      }
      return errorReason
    },
    handleGameOver({ is_win }) {
      if (this.questionType === 'ai') {
        this.answerCorrect = this.calculateWin()
        this.questionDialogConfig.visible = true
        if (!is_win && this.moveErrorStep && this.moveErrorStep.length > 1) {
          this.errorReason = `两次违规走法-（${this.moveErrorStep.join('、')}）`
        }
      } else if (this.questionType === 'national_iconic') {
        this.answerCorrect = is_win ? 1 : 0
      }
    },
    async getQuestion() {
      let testPaper = this.testPaper
      let detailList = testPaper.detailList
      let currQuestionTypeIdx = this.currQuestionTypeIdx
      let currQuestionIdx = this.currQuestionIdx
      let uids = this.uids
      let { paperUid, typeUid, typeCode, count } = detailList[currQuestionTypeIdx]
      if (currQuestionIdx + 1 >= count && currQuestionTypeIdx + 1 >= detailList.length) {
        this.lastQuestion = true
        this.endFlag = true
      }
      if (!this.newQuestionFlag && this.currQuestion.uid) {
        this.question = this.currQuestion
      } else {
        let questionResult = await gradingAPI.getRandomQuestion({ paperUid, typeUid, levelUid: testPaper.levelUid, uids })
        let question = questionResult.data
        question.answerList = question.answerList ? question.answerList.sort((prev, next) => {
          return prev.number.localeCompare(next.number)
        }) : []
        this.question = { ...question, ...{ typeCode } }
        let uidsArray = uids ? uids.split(',') : []
        uidsArray.push(question.uid)
        this.$store.commit('grading/setCurrQuestionIdx', currQuestionIdx)
        this.$store.commit('grading/setCurrQuestionTypeIdx', currQuestionTypeIdx)
        this.$store.commit('grading/setCurrQuestion', this.question)
        this.$store.commit('grading/setUids', uidsArray.join(','))
        this.$store.commit('grading/setNewQuestionFlag', false)
        this.eachTime === 0 && this.$store.commit('grading/setEachTime', detailList[currQuestionTypeIdx].eachTime)
      }
      this.answerCorrect = 0
      this.errorReason = ''
      this.initGameConfig()
    },
    initGameConfig() {
      let gameConfig = store.get(WS_GAME_CONFIGS)
      gameConfig = { ...gameConfig, ...{ mode: this.eachTime + ',1', questionType: this.questionType } }
      if (['national_iconic', 'ai'].includes(this.question.typeCode)) {
        newGame.load(this.question.fen)
        const playerTurn = newGame.turn()
        gameConfig = { ...gameConfig, ...{ replay: false, player_turn: playerTurn || 'w', player_turn_color: playerTurn === 'w' ? 'white' : 'black', other_side_turn: playerTurn === 'w' ? 'b' : 'w' } }
      }
      store.set(WS_GAME_CONFIGS, gameConfig)
    },
    reset() {
      // this.back()
      const { game, board } = this.$refs.chessQuestionRef.$refs.chessRef
      const fen = this.question.fen
      game.load(fen)
      board.position(fen, false)
    },
    /**
     *
     * @param {Boolean} over 倒计时结束直接进入下一题不用弹窗提示
     */
    async next(over = false) {
      if (this.switchQuestionFlag) return
      let question = this.question; let warnFlag = false
      if (['singel_selection', 'true_or_false', 'multi_selection', 'national_iconic'].includes(question.typeCode)) {
        if (question.typeCode === 'national_iconic') {
          const { game } = this.$refs.chessQuestionRef.$refs.chessRef
          if (game.history().length === 0) warnFlag = true
        } else {
          let choicesAnswer = question.answerList.filter(answer => {
            return answer.choiced
          })
          if (choicesAnswer && choicesAnswer.length === 0) warnFlag = true
        }
      }

      if (warnFlag && !over) {
        this.$confirm('您当前还未作答，是否跳过改题到下一题？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleNext()
        })
      } else {
        this.handleNext()
      }
    },
    async handleNext() {
      this.switchQuestionFlag = true
      await this.submitCurrQuestion()
      await this.getNextQuestion()
      this.switchQuestionFlag = false
    },
    async submitCurrQuestion() {
      let question = this.question
      let params = {
        endFlag: this.endFlag,
        orderUid: this.orderUid,
        typeUid: question.typeUid, // 题目的类型
        typeName: question.typeName, // 题目类型名称
        typeCode: question.typeCode, // 题目类型code
        topic: question.topic, // 题目
        description: question.description, // 题目说明
        level: question.level, // 题目等级
        levelUid: question.levelUid, // 等级uid
        finalSituation: question.finalSituation, // 最终局面
        imgUrl: question.imgUrl,
        fen: question.fen,
        userAnswer: '', // 用户作答答案，多选答案为序号“，”拼接
        userSituation: '', // 用户作答的fen
        correct: this.answerCorrect, // 是否正确 0否 1是
        score: question.score, // 本题分数
        testLogUid: this.testLogUid, // 考试uid，保存本次考试返回的uid
        originQuestionUid: question.uid, // 题目的原uid
        remainderTime: this.totalTime, // 剩余时间
        errorReason: this.getErrorReason() // 失败原因
      }
      if (['singel_selection', 'true_or_false', 'multi_selection'].includes(question.typeCode)) {
        let answerCorrect = 0
        let answerList = question.answerList
        let choicesAnswer = answerList.filter(answer => {
          return answer.choiced
        })
        let answerArray = choicesAnswer.map(choiceAnswer => {
          return choiceAnswer.number
        })
        if (choicesAnswer && choicesAnswer.length > 0) {
          if (question.typeCode === 'multi_selection') {
            let trueArray = answerList.filter(answer => {
              return answer.correct === 1
            })
            if (choicesAnswer.length === trueArray.length) {
              answerCorrect = 1
              choicesAnswer.forEach(answer => {
                const findIdx = trueArray.findIndex(trueAnswer => answer.number === trueAnswer.number)
                if (findIdx === -1) {
                  answerCorrect = 0
                }
              })
            } else {
              answerCorrect = 0
            }
          } else {
            answerCorrect = choicesAnswer[0].correct
          }
        }
        params = { ...params, ...{ userAnswer: answerArray.join(','), correct: answerCorrect } }
      } else { // 国际象棋战术题和国际象棋实战对决
        if (this.$refs.chessQuestionRef) {
          const { game } = this.$refs.chessQuestionRef.$refs.chessRef
          params.correct = this.answerCorrect
          params.userAnswer = game.pgn()
          params.userSituation = game.fen()
          this.questionDialogConfig.visible = false
        }
      }
      const { code } = await gradingAPI.testQuestionSave(params)
      if (code === 10005) {
        this.getGradingResult()
      }
      // 停止题目播报
      this.$refs.broadcastRef && this.$refs.broadcastRef.handlePause()
    },
    async getGradingResult() {
      let gradingResult = await gradingAPI.getTestLogOne({ uid: this.testLogUid })
      let promotionResult = await gradingAPI.getPromotionResult({ uid: this.testLogUid })
      this.questionDialogConfig.visible = false
      let times = promotionResult.data.totalTime || 0
      this.resultDialogConfig = Object.assign(this.resultDialogConfig, {
        visible: true,
        result: {
          ...gradingResult.data,
          ...promotionResult.data,
          totalTime: `${parseInt(times / 60)}分${times % 60}秒`
        }
      })
      console.log('resultDialogConfig', this.resultDialogConfig)
      this.scoreLevel = getScoreLevel(this.resultDialogConfig.result.score, this.resultDialogConfig.result.passScore)
      timer.stop()
      if (gradingResult.data.pass === 0) { // 通过
        const userInfo = store.get(USER_INFO) || {}
        store.set(USER_INFO, { ...userInfo, ...{ levelName: gradingResult.data.paperLevel } })
      }
    },
    async getNextQuestion() {
      let testPaper = this.testPaper
      let detailList = testPaper.detailList
      let currQuestionTypeIdx = this.currQuestionTypeIdx
      let currQuestionIdx = this.currQuestionIdx
      let { count } = detailList[currQuestionTypeIdx]
      if (currQuestionIdx < count && currQuestionTypeIdx < detailList.length) {
        currQuestionIdx += 1
        if (currQuestionIdx === count) {
          if (currQuestionTypeIdx < detailList.length - 1) {
            currQuestionTypeIdx += 1
            currQuestionIdx = 0
          } else {
            this.lastQuestion = true
            this.endFlag = true
            return
          }
        }
        this.$store.commit('grading/setCurrQuestionIdx', currQuestionIdx)
        this.$store.commit('grading/setCurrQuestionTypeIdx', currQuestionTypeIdx)
        this.$store.commit('grading/setEachTime', 0)
        this.$store.commit('grading/setNewQuestionFlag', true)
        this.$store.commit('grading/setMoveErrorCount', 0)
        this.$store.commit('grading/setMoveErrorStep', [])
        await this.getQuestion()
      }
    },
    submit: debounce(async function() {
      await this.submitCurrQuestion()
      await this.getGradingResult()
    }),
    back() {
      if (this.visible) return
      const { game, board } = this.$refs.chessQuestionRef.$refs.chessRef
      const { player_turn } = this.configs
      const turn = game.turn()
      game.undo()
      if (!this.free && turn === player_turn) game.undo()
      board.position(game.fen())
    },
    surrender() {
      if (this.visible) return
      this.$confirm('您是否确认认输？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.answerCorrect = 0
          this.questionDialogConfig.visible = true
          this.errorReason = '投降认输'
        })
    },
    timeOver() {
      if (this.animationTimes > 0) return
      if (this.questionType === 'ai') {
        this.questionDialogConfig.visible = true
        this.answerCorrect = this.calculateWin()
        this.errorReason = this.answerCorrect === 0 ? '未在规定时间内完成作答' : ''
      } else {
        this.next(true)
      }
    },
    handleMainPager() {
      this.$store.dispatch('grading/clearGradingData')
      this.$router.replace('/home')
    },
    handleReplay(testLogUid) {
      this.$router.replace({ path: '/grading/replay', query: { testLogUid } })
    },
  },
}
</script>

<style lang="scss" scoped>
  .grading-index-page {
    height: 100vh;
    &__content {
      flex: 1;
      background: url('../../assets/images/grading/bg.png') no-repeat left top;
      background-size: 100% 100%;
    }
    .buttons {
      padding: val(27) 0;
    }
    ::v-deep {
      .dialog__box {
        width: unset;
        padding: 0;
        min-height: unset;
      }
    }
    .question {
      &.fixed {
        position: fixed;
        left: 9999px;
      }
    }
    ::v-deep .question__dialog{
      &__content {
        position: relative;
        width: val(314);
        .next-question {
          cursor: pointer;
          position: absolute;
          font-size: val(18);
          font-weight: 400;
          line-height: val(24);
          color: #3E2C00;
          left: 50%;
          bottom: val(15);
          transform: translateX(-50%);
        }
      }
    }

    ::v-deep .result__dialog {
      &__content {
        position: relative;
        &__image {
          position: relative;
          width: val(570);
          .silk {
            position: absolute;
            left: val(-38);
            top: val(-39);
            width: val(660);
          }
        }
        &__info {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          .total-score {
            display: flex;
            justify-content: center;
            position: absolute;
            left: val(36);
            right: 0;
            top: val(214);
            height: val(38);
            img {
              width: auto;
              height: 100%;
            }
            &.fail {
              left: 0;
            }
          }
          .result-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            top: val(275);
            left: val(36);
            right: 0;
            p {
              display: flex;
              align-items: center;
              font-size: val(18);
              line-height: val(36);
              color: #373538;
              span {
                margin: 0 val(3);
                font-size: val(24);
                color: #56300B;
              }
            }
            &.fail {
              left: 0;
              p {
                color: #61605F;
              }
            }
          }
          .tips {
            position: absolute;
            // top: val(267);
            bottom: val(-23);
            left: 0;
            right: 0;
            text-align: center;
            transform: translateY(100%);
            p {
              white-space: nowrap;
              font-size: val(18);
              line-height: val(18);
              transform: scale(0.8);
              color: #FFE8BC;
            }
            &.fail p{
              color: #fff;
            }
          }
          .level {
            position: absolute;
            bottom: val(64);
            left: val(282);
            right: val(247);
            display: flex;
            justify-content: center;
            span {
              font-size: val(37);
              font-weight: 400;
              color: #F5E08A;
            }
          }
        }
      }
      &__buttons {
        margin-top: val(72);
        &__button {
          cursor: pointer;
          width: val(160);
          height: val(56);
          line-height: val(56);
          text-align: center;
          border-radius: val(6);
          background: #ffe8bc;
          font-size: val(24);
          font-weight: 400;
          color: #8a6442;
          &:first-of-type {
            margin-right: val(20);
          }
        }
      }
    }
    .enter-animation {
      margin-top: val(319);
      .question-type {
        font-size: val(120);
        font-family: xiaowei;
        line-height: val(133);
        color: #3E2C00;
        margin-bottom: 40px;
      }
      .count-down {
        text-align: center;
        font-size: val(24);
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: val(24);
        color: #3E2C00;
        span {
          color: #DCAD81;
        }
      }
    }
  }
</style>
